module.exports = __webpack_public_path__ + "static/img/04bg.18e337a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/04bg.png
// module id = jG4D
// module chunks = 1